<div class="header-container flex items-center justify-start pl-5 pr-5">
  <div class="header-logo w-[15%] max-w-[120px]">
    <a class="" href="/">
      <img alt="" class="header-logo-icon" src="assets/images/go-ahead-logo-dark.svg" />
    </a>
  </div>

  <gan-menu class="menu"></gan-menu>

  <div class="header-right-section">
    <div class="flex items-center justify-end">
      <div class="hidden lg:flex">
        <gan-dark-mode-toggler></gan-dark-mode-toggler>

        <gan-language-switcher></gan-language-switcher>
      </div>

      @if (msAccount(); as msAccount) {
        <div class="logout-section pl-5">
          <button mat-button [matMenuTriggerFor]="menu">
            <span class="flex items-center">
              <span class="username" [innerText]="msAccount.name"></span>
              <gan-lucid-icon iconId="chevron-down" class="flex! justify-center!" />
            </span>
          </button>

          <mat-menu #menu="matMenu" xPosition="before">
            <button class="max-lg:block! hidden!" mat-menu-item>
              <gan-dark-mode-toggler></gan-dark-mode-toggler>
            </button>

            <button class="max-lg:block! hidden!" mat-menu-item>
              <gan-language-switcher></gan-language-switcher>
            </button>

            <button mat-menu-item (click)="onLogout()">Sign out</button>
          </mat-menu>
        </div>
      }
    </div>
  </div>
</div>
